import {
  IAddress,
  TVehicleVariables,
  TGenericVehicleVariables,
  TAZVehicleVariables,
  TSCVehicleVariables,
  TCAVehicleVariables,
} from '../../../interfaces';
import { getHiddenVehicleCoverageFields } from '../getHiddenVehicleCoverageFields';

function getUpdatedVehicleVariables({
  year,
  ownership_status,
  variables,
  isNewVehicle = false,
  baseVehicleYear,
  garage_address,
}: {
  year: number;
  ownership_status: 'owned' | 'leased' | 'financed';
  variables?: TVehicleVariables;
  garage_address: IAddress;
  isNewVehicle?: boolean;
  baseVehicleYear?: number;
}) {
  const {
    region: { code: regionCode },
  } = garage_address;
  const hiddenCoverages = getHiddenVehicleCoverageFields(
    {
      year,
      ownership_status,
      garage_address,
    },
    { baseVehicleYear }
  );

  const isLeasedOrFinanced = ['leased', 'financed'].includes(ownership_status);

  if (!variables) {
    if (isLeasedOrFinanced) {
      return {
        comprehensive_deductible: '1000',
        collision_deductible: '1000',
      };
    }
    return {};
  }

  switch (regionCode) {
    case 'CA':
      return {
        ...variables,
        ...(['leased', 'financed'].includes(ownership_status) && {
          comprehensive_deductible:
            isNewVehicle || !variables.comprehensive_deductible
              ? '1000'
              : variables.comprehensive_deductible,
          collision_deductible:
            isNewVehicle || !variables.collision_deductible
              ? '1000'
              : variables.collision_deductible,
        }),
      } as TCAVehicleVariables;
    case 'IL':
    case 'IN':
    case 'MO':
    case 'OH':
    case 'TN':
    case 'TX':
      return {
        ...variables,
        new_car_replacement: hiddenCoverages.includes('new_car_replacement')
          ? false
          : variables.new_car_replacement,
        gap: hiddenCoverages.includes('gap') ? false : variables.gap,
        oem_parts: hiddenCoverages.includes('oem_parts')
          ? false
          : variables.oem_parts,
        side_hustle: variables.comprehensive_deductible
          ? variables.side_hustle
          : false,
        ...(['leased', 'financed'].includes(ownership_status) && {
          comprehensive_deductible:
            isNewVehicle || !variables.comprehensive_deductible
              ? '1000'
              : variables.comprehensive_deductible,
          collision_deductible:
            isNewVehicle || !variables.collision_deductible
              ? '1000'
              : variables.collision_deductible,
        }),
      } as TGenericVehicleVariables;
    case 'AZ':
      return {
        ...variables,
        new_car_replacement: hiddenCoverages.includes('new_car_replacement')
          ? false
          : variables.new_car_replacement,
        gap: hiddenCoverages.includes('gap') ? false : variables.gap,
        oem_parts: hiddenCoverages.includes('oem_parts')
          ? false
          : variables.oem_parts,
        side_hustle: variables.comprehensive_deductible
          ? variables.side_hustle
          : false,
        ...(['leased', 'financed'].includes(ownership_status) && {
          comprehensive_deductible:
            isNewVehicle || !variables.comprehensive_deductible
              ? '1000'
              : variables.comprehensive_deductible,
          collision_deductible:
            isNewVehicle || !variables.collision_deductible
              ? '1000'
              : variables.collision_deductible,
        }),
      } as TAZVehicleVariables;
    case 'SC':
    default:
      return {
        ...variables,
        loan_lease_payoff: hiddenCoverages.includes('loan_lease_payoff')
          ? false
          : variables.loan_lease_payoff,
        new_car_replacement: hiddenCoverages.includes('new_car_replacement')
          ? false
          : variables.new_car_replacement,
        oem_parts: hiddenCoverages.includes('oem_parts')
          ? false
          : variables.oem_parts,
        ...(['leased', 'financed'].includes(ownership_status) && {
          comprehensive_deductible:
            isNewVehicle || !variables.comprehensive_deductible
              ? '1000'
              : variables.comprehensive_deductible,
          collision_deductible:
            isNewVehicle || !variables.collision_deductible
              ? '1000'
              : variables.collision_deductible,
        }),
      } as TSCVehicleVariables;
  }
}

export default getUpdatedVehicleVariables;
